const STREAMING_AI_MESSAGE_ID_PREFIX = "streaming-ai-";

interface StreamingMessageLike {
  readonly _id: unknown;
  readonly content?: string | null;
}

export const getStreamingAiMessageId = (
  threadId: string,
  startedAt: Date,
): string =>
  `${STREAMING_AI_MESSAGE_ID_PREFIX}${threadId}-${startedAt.getTime()}`;

export const isStreamingAiMessage = (message: StreamingMessageLike): boolean =>
  String(message._id).startsWith(STREAMING_AI_MESSAGE_ID_PREFIX);

export const hasVisibleStreamingAiContent = (
  message: StreamingMessageLike,
): boolean =>
  isStreamingAiMessage(message) &&
  typeof message.content === "string" &&
  message.content.trim().length > 0;
